import React from 'react';

export const b = (chunks: React.ReactNode): React.ReactNode => <b>{chunks}</b>;

export const p = (chunks: React.ReactNode): React.ReactNode => <p>{chunks}</p>;

export const span = (chunks: React.ReactNode): React.ReactNode => <span>{chunks}</span>;

export const getHyperlink = (props: React.AnchorHTMLAttributes<HTMLAnchorElement>) =>
  (chunks: React.ReactNode): React.ReactNode => <a {...props}>{chunks}</a>;
